import isString from 'lodash/isString';
import assign from 'lodash/assign';
import isObject from 'lodash/isObject';
import forEach from 'lodash/forEach';

import config from '../../../config';
import Auth from './Auth';
import bus from './bus';
import { HttpNotFoundError, HttpNotAuthorizedError, HttpForbiddenError, HttpServerError } from '../errors';


class Http {
  static head(url, options) {
    return _callRequest('HEAD', url, options);
  }
  static get(url, options) {
    return _callRequest('GET', url, options);
  }

  static post(url, options) {
    return _callRequest('POST', url, options);
  }

  static put(url, options) {
    return _callRequest('PUT', url, options);
  }

  static delete(url, options) {
    return _callRequest('DELETE', url, options);
  }

  static request(options) {
    let url = options.url;
    if (!url.match(/^https?:\/\//)) {
      url = `${config.api.default.replace(/\/$/, '')}/${url.replace(/^\//, '')}`;
    }
    const qs = options.query || options.qs;
    if (qs) {
      const parts = [];
      forEach(qs, (val, key) => {
        parts.push(`${key}=${encodeURIComponent(val)}`);
      });
      if (parts.length) {
        url += url.indexOf('?') === -1 ? '?' : '&';
        url += parts.join('&');
      }
    }

    const headers = {
      ...options.headers,
      'auth-token': Auth.getToken() || ''
    };
    return fetch(url, {
      method: options.method || (options.body ? 'POST' : 'GET'),
      headers: (() => {
        // unless the body is a string we assume that we are doing a JSON request
        if (options.multipart || (options.body && isString(options.body))) {
          return headers;
        }
        return assign({
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }, headers);
      })(),
      body: (() => {
        if (options.body && isObject(options.body)) {
          if(options.multipart){
            const formData  = new FormData();
            Object.keys(options.body)
              .forEach(key=>{
                formData.append(key, options.body[key]);
              });
            return formData
          }
          return JSON.stringify(options.body);
        }
        return options.body;
      })(),
      //credentials: options.credentials || 'include' // same-origin (sets if cookies should be sent, include will do cross origin)
    })
      .then(response =>
        // todo: not taking non json responses into consideration
        response.json()
          .then((data) => {
            bus.trigger('http-request-completed', {response, data});
            if (response.status >= 200 && response.status < 300) {
              const authToken = response.headers.get('set-auth-token');
              if(authToken){
                if(authToken === 'clear'){
                  Auth.removeToken();
                }else{
                  Auth.setToken(authToken);
                }

              }
              return data;
            }
            let error;
            if (response.status === 500) {
              error = new HttpServerError(/*response.statusText*/);
            } else if (response.status === 401) {
              error = new HttpNotAuthorizedError(/*response.statusText*/);
            } else if (response.status === 403) {
              error = new HttpForbiddenError(/*response.statusText*/);
            } else if (response.status === 404) {
              error = new HttpNotFoundError(/*response.statusText*/);
            } else {
              error = new Error(response.statusText);
            }
            error.data = data;
            throw error;
          }));
  }

  static rpc(remoteMethod, data) {
    return Http.request({
      url: `/api/${remoteMethod}`,
      method: 'POST',
      body: data
    });
  }
}

function _callRequest(method, url, options) {
  if (isString(url)) {
    return Http.request({
      ...options,
      url,
      method
    });
  }
  // fixme: I changed this since it looked wrong
  return Http.request({
      ...url,
    method
  });
}

export default Http;



// WEBPACK FOOTER //
// ./src/app/libs/Http.js